import React, {useEffect, useState} from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import {Drawer, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import moment from "moment/moment";

export default function StaffInvoicesDetailsBox ({row,isOpen,setIsOpen}) {

    const [schedule,setSchedule] = useState([]);
    const [loading,setLoading] = useState(true);

    useEffect(() => {

        FunctionsData.fetchDataGet(
            FunctionsData.getApiUrl('/api/merco/invoice-summary/')+row.schedule_id,
            setSchedule,loading,setLoading
        )

    }, [loading,row.schedule_id])

    if(loading === true) return null;
    return (
        <Drawer open={isOpen} onClose={() => setIsOpen(false)} anchor={"right"} >
            <div style={{width:550, padding:20}}>

                <div style={{marginBottom:20}}>
                    <h3>Schedule: {row.schedule_id}</h3>
                </div>

                <div style={{marginBottom:20}}>
                    Clinic: {row.vet_name}<br />
                    Clinic email: {row.vet_email}<br />
                    Clinic Merco ID: {row.vet_merco_id}
                </div>

                <hr  style={{marginBottom:20}} />

                <div style={{marginBottom:20}}>
                    <h3>Vouchers: {row.vouchers.length}</h3>
                </div>

                <div style={{marginBottom:20}}>
                    <h3>Amount: ${(row.total_amount).toFixed(2)}</h3>
                </div>

                <hr style={{marginBottom:20}} />

                <div style={{marginBottom:20}} >
                   <TableContainer>
                        <Table sx={{ minWidth: 500 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Voucher</TableCell>
                                    <TableCell align="left">Amount</TableCell>
                                    <TableCell align="left">Surgery Date</TableCell>
                                    <TableCell align="left">Type / Gender</TableCell>
                                    <TableCell align="left">Sponsor</TableCell>
                                    {/* <TableCell align="left">PaidDate</TableCell>
                                    <TableCell align="left">Invoice Number</TableCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {schedule.map((row) => (
                                    <TableRow
                                        key={row.sn}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row"> {row.sn}</TableCell>
                                        <TableCell align="left">{row.a_surgery_amount}</TableCell>
                                        <TableCell align="left">{moment(row.a_date_surgery).format('DD/MM/YYYY')}</TableCell>
                                        <TableCell align="left" style={{whiteSpace:'nowrap'}}>{row.a_type_surgery} / {row.a_gender}</TableCell>
                                        <TableCell align="left">{(row.sponsor) ? row.sponsor : 'n/a'}</TableCell>
                                       {/* <TableCell align="left">{moment(row.voucher_paid_date).format('DD/MM/YYYY')}</TableCell>
                                        <TableCell align="left">{row.Invoice_Number}</TableCell> */}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

            </div>
        </Drawer>
    )
}
